module.exports = __webpack_public_path__ + "img/mobile_popup.48049540.png";